import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { KeycloakProvider } from '@europrocurement/l2d-keycloak';

import L2DApiProvider from '@europrocurement/l2d-domain/providers/L2DApiProvider/L2DApiProvider';
import {
    APIS_ENUM,
    getApiConfiguration,
    getBasePathFromApiName,
    INIT_STATE,
} from '@europrocurement/l2d-domain';
import { SearchBarProvider } from '@europrocurement/l2d-modules';
import { ParcoursFormalitreHeaderProvider } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider';
import { WebsocketProvider } from '@europrocurement/l2d-websocket';
import App from './App';

import { keycloak, updateToken } from './keycloak';
import ReduxProvider from './ReduxProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const apiConfiguration = {
    offre: getApiConfiguration(APIS_ENUM.OFFRE, updateToken),
    formalite: getApiConfiguration(APIS_ENUM.FORMALITE, updateToken),
    tiers: getApiConfiguration(APIS_ENUM.TIERS, updateToken),
    siren: getApiConfiguration(APIS_ENUM.SIREN, updateToken),
    formulaire: getApiConfiguration(APIS_ENUM.FORMULAIRE, updateToken),
    utilisateur: getApiConfiguration(APIS_ENUM.UTILISATEUR, updateToken),
    facturation: getApiConfiguration(APIS_ENUM.FACTURATION, updateToken),
    societe: getApiConfiguration(APIS_ENUM.SOCIETE, updateToken),
    annoncesLegales: getApiConfiguration(APIS_ENUM.AL, updateToken),
    geoloc: getApiConfiguration(APIS_ENUM.GEOLOC, updateToken),
    mail: getApiConfiguration(APIS_ENUM.MAIL, updateToken),
    sign: getApiConfiguration(APIS_ENUM.SIGN, updateToken),
    iaServices: getApiConfiguration(APIS_ENUM.IASERVICES, updateToken),
};

root.render(
    <KeycloakProvider
        initOptions={{
            onLoad: 'login-required',
            checkLoginIframe: false,
        }}
        authClient={keycloak}
    >
        <L2DApiProvider apiConfiguration={apiConfiguration}>
            <ReduxProvider>
                <SearchBarProvider>
                    <ParcoursFormalitreHeaderProvider>
                        <WebsocketProvider
                            baseWebsocketUrl={
                                getBasePathFromApiName(APIS_ENUM.WS_MESSAGERIE) ||
                                INIT_STATE.api.wsMessagerie
                            }
                        >
                            <App />
                        </WebsocketProvider>
                    </ParcoursFormalitreHeaderProvider>
                </SearchBarProvider>
            </ReduxProvider>
        </L2DApiProvider>
    </KeycloakProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
